/**
 * 二维码生成器/图片显示组件
 */
import React, { FC, useEffect, useState } from 'react'
import { Tooltip, Button } from 'antd'
import classNames from 'classnames'
import QRCode from 'qrcode'

interface QRCodeBuilderProps {
  className?: string
  url: string
  size?: number
  download?: boolean
  fileName?: string
  style?: React.CSSProperties
  /** 是否生成二维码，false 则直接显示图片 */
  generateQRCode?: boolean
}

export const QRCodeBuilder: FC<QRCodeBuilderProps> = (props) => {
  const { className, url, size, download = true, fileName, style, generateQRCode = true } = props
  const [qrcodeUrl, setQrcodeUrl] = useState<string>('')

  useEffect(() => {
    if (generateQRCode) {
      QRCode.toDataURL(url, {
        margin: 1,
        color: {
          dark: '#000',
          light: '#fff',
        },
      })
        .then((dataUrl) => {
          setQrcodeUrl(dataUrl)
        })
        .catch((error) => {
          console.error('二维码生成失败', error)
        })
    }
  }, [url, generateQRCode])

  const displayUrl = generateQRCode ? qrcodeUrl : url
  const altText = generateQRCode ? '二维码' : '图片'
  const defaultFileName = generateQRCode ? '二维码图片.png' : '图片.png'

  return (
    <div className={classNames(className)} style={style}>
      <Tooltip color="#fff" title={
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img style={{ width: 124, height: 124 }} src={displayUrl} alt={altText} />
          {download && <Button href={displayUrl} download={fileName || defaultFileName} type="link" id="downloadBtn">下载</Button>}
        </div>
      }>
        <img style={{ width: size || 20, height: size || 20 }} src={displayUrl} alt={`${altText}缩略图`} />
      </Tooltip>
    </div>
  )
}
